class ProductFormVariants extends HTMLElement {
  constructor() {
    super();

    const elements = {
      form: this.closest("form"),
      selects: this.querySelectorAll("[data-local-select]"),
      swatches: this.querySelector("[data-local-swatches]")
    };

    elements.selects.forEach((element) => {
      element.addEventListener("change", (event) => {
        const variant = get_variant();

        document.dispatchEvent(new CustomEvent("productformvariants:change", {
          detail: {
            variant: variant
          }
        }));

        Theme.URLParams.set("variant", variant.id);
      });
    });

    elements.swatches.addEventListener("click", (event) => {
      const value = event.target.getAttribute("title");

      if (!value) {
        return;
      }

      elements.swatches.querySelectorAll(":scope > *").forEach((element) => {
        element.classList.remove("state--active");
        event.target.classList.add("state--active");
      });

      const swatches_select = Array.from(elements.selects).filter((element) => {
        return element.name == elements.swatches.dataset.name;
      })[0];

      swatches_select.value = value;
      swatches_select.dispatchEvent(new Event("change"));
    });

    function get_variant() {
      const variant_title = get_variant_title();
      const variant = get_variant_by_title(variant_title);

      return variant;
    }

    function get_variant_title() {
      return Array.from(elements.selects)
        .map(element => element.value)
        .join(" / ")
        .trim();
    }

    function get_variant_by_title(title) {
      let selected_variant = null;

      Theme.Liquid.product.variants.forEach((variant) => {
        if (title == variant.title) {
          selected_variant = variant;
        }
      });

      return selected_variant;
    }
  }
}

customElements.define("product-form-variants", ProductFormVariants)